import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import CountDown from 'components/participates/countDown';
import { changeOfferAgain, offerNow } from 'slices/offerSlice';
import { useParams } from 'react-router-dom';
import { activeButton } from 'slices/countDownSlice';
import LoaderCP from 'components/loader';
import { MEMBER_URL, SUBASTAS_URL } from '../../constants/Constants';
import ItemPeopleOffer from './ItemPeopleOffer';

const ItemCanOffer = () => {
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.user);
  // const status = 'success';
  const { disableButton } = useSelector((state) => state.countDown);
  const { id } = useParams();
  const { auctionId, allOffers,
    recentOffer } = useSelector((state) => state.offersSocket.offersSock);

  const [dataSocket, setDataSocket] = useState(false);

  const { offers, initialOffer, increments,
    closeDate, serverDate, maxOffer, minimumOffer,
    urlName } = useSelector((state) => state.detail.detail);

  const { type } = useSelector((state) => state.offer.offer);

  const [finalOffer, setFinalOffer] = useState(null);

  const finalOfferFunc = () => {
    let hasOffer = null;
    if (!dataSocket) {
      if (offers.length >= 1) {
        hasOffer = offers[0].offer + increments;
      } else {
        hasOffer = initialOffer + increments;
      }
    } else {
      hasOffer = recentOffer.offer + increments;
    }
    return setFinalOffer(hasOffer);
  };

  const [lastOffer, setLastOffer] = useState(null);
  const [isMultiple, setIsMultiple] = useState(true);
  const [disableButtonOffer, setDisableButtonOffer] = useState(false);

  const lasOfferFunc = () => {
    let last = null;
    if (!dataSocket) {
      if (offers.length >= 1) {
        last = offers[0].offer;
      } else {
        last = initialOffer;
      }
    } else {
      last = recentOffer.offer;
    }
    return setLastOffer(last);
  };

  useEffect(() => {
    finalOfferFunc();
    lasOfferFunc();
  }, [dataSocket, recentOffer]);

  const handleLess = () => {
    let result = finalOffer - increments;
    if (result < lastOffer + increments) {
      result = lastOffer + increments;
    }
    setFinalOffer(result);
  };

  const handleMore = () => {
    let result = finalOffer + increments;
    if (maxOffer !== null) {
      if (result >= lastOffer + maxOffer) {
        result = lastOffer + maxOffer;
      }
    }
    setFinalOffer(result);
  };

  const handleChange = (e) => {
    const result = e.target.value;
    setFinalOffer(result);
  };

  const handleBlur = (e) => {
    let result = Number(e.target.value);
    if (result < lastOffer + increments) {
      result = lastOffer + increments;
    }
    if (maxOffer !== null) {
      if (result >= lastOffer + maxOffer) {
        result = lastOffer + maxOffer;
      }
    }
    setFinalOffer(result);
  };

  useEffect(() => {
    const resultIsMultiple = finalOffer % increments;
    if (resultIsMultiple === 0) {
      setIsMultiple(true);
      setDisableButtonOffer(false);
    } else {
      setIsMultiple(false);
      setDisableButtonOffer(true);
    }
  }, [finalOffer]);

  const validateSocketData = () => {
    let data = false;
    if (auctionId !== undefined && auctionId !== undefined) {
      if (auctionId.toString() === id.toString()) {
        data = true;
        setFinalOffer(recentOffer.offer + increments);
      }
    }
    return setDataSocket(data);
  };

  useEffect(() => {
    if (auctionId !== undefined) {
      validateSocketData();
    }
  }, [auctionId]);

  const handleOffer = async () => {
    const data = {
      offer: finalOffer,
      auctionId: Number(id),
    };

    dispatch(offerNow(data));
    dispatch(changeOfferAgain());
    validateSocketData();
  };

  const handleLogin = () => {
    Cookies.set('redirect', `subastas/${urlName}/${id}`);
    window.location = `${MEMBER_URL}/login?url=${SUBASTAS_URL}/#/subastas/${urlName}/${id}`;
  };

  const [selected, setSelected] = useState(true);
  const handleToogle = () => {
    setSelected(!selected);
  };

  const scrollEvent = () => {
    document.addEventListener('scroll', () => {
      const element = document.querySelectorAll('.sticky-resumen-mobile')[0];
      if (element !== undefined) {
        if (window.scrollY <= 110) {
          element.classList.remove('active');
        } else {
          element.classList.add('active');
        }
      }
    });
  };

  useEffect(() => {
    scrollEvent();
    dispatch(activeButton());
  }, []);

  const thousands = (num) => {
    return num.toString().split('').reverse().join('')
      .replace(/(?=\d*\.?)(\d{3})/g, '$1,')
      .split('')
      .reverse()
      .join('')
      .replace(/^[,]/, '');
  };

  return (

    <div className="d-flex flex-column-reverse flex-sm-column">
      <div className="bg-westar py-15 p-sm-3 d-block d-sm-none sticky-resumen-mobile">
        <div className="wrap">
          <button
            type="button"
            className="bg-westar header d-flex justify-content-between btn-link text-left"
            onClick={handleToogle}>
            <div className="title">
              <h3 className="text-tangaroa">Oferta inicial: </h3>
              <h3 className="text-tangaroa">
                {`${thousands(initialOffer)} Puntos Aeroméxico Rewards`}
              </h3>
            </div>
            <div className="icon-title font-weight-bold text-tangaroa">
              {selected ? (<i className="fas fa-minus" />) : (<i className="fas fa-plus" />)}
            </div>
          </button>
          {selected && (
            <div className="content bg-westar">
              <div className="wrap-content">
                <p className="mt-30 mb-10">
                  ¿Cuántos Puntos Aeroméxico Rewards quieres ofertar?
                </p>

                {status === '' && <LoaderCP />}

                {status === 'success' && (
                  <div>
                    <div className="input-count d-flex">
                      <button type="button" className="btn-left" onClick={handleLess}>-</button>
                      <input
                        required
                        name="count"
                        placeholder="0"
                        className="input-active text-tangaroa"
                        value={finalOffer}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="number" />
                      <button type="button" className="btn-right" onClick={handleMore}>+</button>
                    </div>

                    {!isMultiple && (
                      <p className="mt-10 text-dark-blue">La oferta no corresponde al incremento definido.</p>
                    )}

                    <p className="mt-30 text-center">
                      {`*Recuerda que los incrementos mínimos en tu puja son de ${thousands(minimumOffer)} Puntos Aeroméxico Rewards`}
                      {maxOffer && ` y el máximo incremento es de ${thousands(maxOffer)} en cada puja.`}
                    </p>
                    <button
                      type="button"
                      className="btn btn-primary w-100 mb-15"
                      onClick={handleOffer}
                      disabled={disableButton || disableButtonOffer}
                      id="sbs-dsb-dgr-btn-mor">
                      Ofertar
                    </button>
                    {type === 'offerOvered' && (
                      <p className="text-apple-blossom">
                        Un Socio ofertó más Puntos Aeroméxico Rewards,
                        elige una cantidad más alta para ofertar.
                      </p>
                    )}
                  </div>
                )}
                {status === 'error' && (
                  <div>
                    <div className="input-count d-flex">
                      <button type="button" className="btn-left disabled" disabled>-</button>
                      <input
                        required
                        name="count"
                        placeholder="0"
                        className="input-disabled"
                        disabled
                        value={dataSocket ? Number(recentOffer.offer)
                          + Number(increments) : finalOffer}
                        type="number" />
                      <button type="button" className="btn-right disabled" disabled>+</button>
                    </div>

                    {!isMultiple && (
                      <p className="mt-10 text-dark-blue">La oferta no corresponde al incremento definido.</p>
                    )}

                    <p className="mt-30 text-center">
                      {`*Recuerda que los incrementos mínimos en tu puja son de ${thousands(minimumOffer)} Puntos Aeroméxico Rewards`}
                      {maxOffer && ` y el máximo incremento es de ${thousands(maxOffer)} en cada puja.`}
                    </p>
                    <button
                      type="button"
                      href={`${MEMBER_URL}/login?url=${SUBASTAS_URL}/#/subastas/${urlName}/${id}`}
                      className="btn btn-secondary w-100 mb-15"
                      onClick={handleLogin}
                      disabled={disableButton || disableButtonOffer}
                      id="sbs-dsb-dgr-btn-mor">
                      Quiero ofertar
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="mb-30 d-none d-sm-block font-weight-bold text-tangaroa">
        Finaliza en:
        <CountDown
          closeDate={closeDate}
          todayDate={serverDate} />
      </div>

      <div className="bg-westar p-0 p-sm-3 pt-5 pb-60 ht-offer d-none d-sm-block text-tangaroa">

        <h3 className="f-600">Oferta inicial: </h3>
        <h3 className="f-600">
          {`${thousands(initialOffer)} Puntos Aeroméxico Rewards`}
        </h3>

        <p className="mt-30 mb-10">
          ¿Cuántos Puntos Aeroméxico Rewards quieres ofertar?
        </p>

        {status === 'pending' && <LoaderCP />}

        {status === 'success' && (
          <div>
            <div className="input-count d-flex">
              <button type="button" className="btn-left" onClick={handleLess}>-</button>
              <input
                required
                name="count"
                placeholder="0"
                className="input-active text-tangaroa"
                value={finalOffer}
                onChange={handleChange}
                onBlur={handleBlur}
                type="number" />
              <button type="button" className="btn-right" onClick={handleMore}>+</button>
            </div>

            {!isMultiple && (
              <p className="mt-10 text-dark-blue">La oferta no corresponde al incremento definido.</p>
            )}

            <p className="mt-30 text-center">
              {`*Recuerda que los incrementos mínimos en tu puja son de ${thousands(minimumOffer)} Puntos Aeroméxico Rewards`}
              {maxOffer && ` y el máximo incremento es de ${thousands(maxOffer)} en cada puja.`}
            </p>
            <button
              type="button"
              className="btn btn-primary w-100 mb-15 f-600"
              onClick={handleOffer}
              disabled={disableButton || disableButtonOffer}
              id="sbs-dsb-dgr-btn-mor">
              Quiero ofertar
            </button>
            {type === 'offerOvered' && (
              <p className="text-error">
                Un Socio ofertó más Puntos Aeroméxico Rewards,
                elige una cantidad más alta para ofertar.
              </p>
            )}
          </div>
        )}
        {status === 'error' && (
          <div>
            <div className="input-count d-flex">
              <button type="button" className="btn-left disabled" disabled>-</button>
              <input
                required
                name="count"
                placeholder="0"
                className="input-disabled"
                disabled
                value={dataSocket ? recentOffer.offer + increments : finalOffer}
                type="number" />
              <button type="button" className="btn-right disabled" disabled>+</button>
            </div>

            {!isMultiple && (
              <p className="mt-10 text-dark-blue">La oferta no corresponde al incremento definido.</p>
            )}

            <p className="mt-30 text-center">
              {`*Recuerda que los incrementos mínimos en tu puja son de ${thousands(minimumOffer)} Puntos Aeroméxico Rewards`}
              {maxOffer && ` y el máximo incremento es de ${thousands(maxOffer)} en cada puja.`}
            </p>
            <button
              type="button"
              href={`${MEMBER_URL}/login?url=${SUBASTAS_URL}/#/subastas/${urlName}/${id}`}
              className="btn btn-secondary w-100 mb-15"
              onClick={handleLogin}
              disabled={disableButton || disableButtonOffer}
              id="sbs-dsb-dgr-btn-mor">
              Quiero ofertar
            </button>
          </div>
        )}
        <div className="d-none d-sm-block">
          <hr className="pl-2 pr-2" />
          <div className={offers.length > 8 ? 'max-offer' : ''}>
            <h3 className="text-left mt-30 text-tangaroa f-600">Últimas ofertas</h3>

            {dataSocket ? (
              allOffers.map((o) => (
                <ItemPeopleOffer
                  key={o.offer}
                  offer={o.offer}
                  person={o.personName}
                  type="Open" />
              ))
            ) : (
              offers.map((o) => (
                <ItemPeopleOffer
                  key={o.offer}
                  offer={o.offer}
                  person={o.personName}
                  type="Open" />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemCanOffer;
